import { Component, OnInit,ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import swal from 'sweetalert2';   
import { CSVSessions, CSVNormix, CSVPlantilla, CSVComparativo, CSVHora} from '../../../CSVModel';     
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import * as moment from 'moment';
import { PdfMakeWrapper,Img} from 'pdfmake-wrapper';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
// importing definitions
import { Txt,Columns,Table,Ul,Ol } from 'pdfmake-wrapper';

import { Table as Table1 } from 'primeng/table';

import { timer } from 'rxjs/observable/timer';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as _ from 'underscore';

import * as FileSaver from 'file-saver';


@Component({
  selector: 'app-frmdc3',
  templateUrl: './frmdc3.component.html',
  styleUrls: ['./frmdc3.component.scss']
})
export class Frmdc3Component implements OnInit {  
  @ViewChild('dt',null)  table: Table1;  
  @ViewChild('dt1',null)  table1: Table1;  
  @ViewChild('dt4',null)  table4: Table1;  
  @ViewChild('dtE',null)  tableE: Table1;  

  //Variables del cliente
  id_sede  = 1;
  rfc = "XXXXXXXXXXXXX";
  razon = "RAZÓN SOCIAL";


  loading: boolean = false;
  usu;

  selmes; mes;
  selano; ano;

  constructor(
    public router: Router,
    public authService: AuthService,    
    public sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {  
    //this.usu = this.authService.leerUsuario()    
    this.usu = 0
    if (this.usu != null){
      this.ls_inicia();
    }else{
      this.router.navigate(['/login']);
    }
  }

  ls_inicia(){
    this.ls_meses();
    
    let dt = moment(new Date(), 'DD-MM-YYYY');
    var sfechanac = dt.format('DD') + "/" +
                dt.format('MM') + "/" +
                dt.format('YYYY');    

    var objIndex = this.mes.findIndex(((itm1 :any) => itm1.id == dt.format('M')));     
    this.selmes = {id: parseInt(dt.format('M').toString()) , nombre: this.mes[objIndex].nombre}

    objIndex = this.ano.findIndex(((itm1 :any) => itm1.id == dt.format('YYYY')));   
    this.selano = {id: parseInt(dt.format('YYYY').toString()) , nombre: this.ano[objIndex].nombre}


    this.ls_sessions('sin_errores');    
  }bndmnugral=true;
  oculta_menu(){
    console.log("-");
    if(this.bndmnugral==true){
      this.bndmnugral=false;
    }else{
      this.bndmnugral=true;
    }
    console.log(this.bndmnugral);
  }

  ls_meses(){
    var _mes = [];    
    _mes.push({ id:  1, nombre: 'enero'});  
    _mes.push({ id:  2, nombre: 'febrero'});  
    _mes.push({ id:  3, nombre: 'marzo'});  
    _mes.push({ id:  4, nombre: 'abril'});  
    _mes.push({ id:  5, nombre: 'mayo'});  
    _mes.push({ id:  6, nombre: 'junio'});  
    _mes.push({ id:  7, nombre: 'julio'});  
    _mes.push({ id:  8, nombre: 'agosto'});  
    _mes.push({ id:  9, nombre: 'septiembre'});  
    _mes.push({ id:  10, nombre: 'octubre'});  
    _mes.push({ id:  11, nombre: 'noviembre'});  
    _mes.push({ id:  12, nombre: 'diciembre'});  
    this.mes = _mes;

    var _año = [];    
    _año.push({ id:  2020, nombre: '2020'});  
    _año.push({ id:  2021, nombre: '2021'});  
    _año.push({ id:  2022, nombre: '2022'}); 
    _año.push({ id:  2023, nombre: '2023'}); 
    _año.push({ id:  2024, nombre: '2024'}); 
    _año.push({ id:  2025, nombre: '2025'}); 
    _año.push({ id:  2026, nombre: '2026'}); 
    _año.push({ id:  2027, nombre: '2027'}); 
    _año.push({ id:  2028, nombre: '2028'}); 
    _año.push({ id:  2029, nombre: '2029'}); 
    _año.push({ id:  2030, nombre: '2030'}); 
    this.ano = _año;
  }


  
  public ses: any;
  Vcurso:any;
  VTrainer:any;
  Vproveedor:any;
  VArea:any;
  USUARIO=[
    {
      apellidoP:"Mejia",
      apellidoM:"Guadarrama",
      nombre:"Sebas",
      SHCPT:"MEGS950718940",
      ocupacion:"trabajador",
      Puesto:"trabajador",
      nombreE:"fulanita",
      SHCPTE:"MEGS950718940",
      IMSS:"Y2345678901",
      actividad:"DOMAR LEONES",
      nombreP:"para dumys",
      duracion:"5h",
      anioI:"95",
      mesI:"07",
      diaI:"18",
      anioF:"95",
      mesF:"97",
      diaF:"18",
      nombreC:"maestro",
      nombreI:"istructor",
    
      nombreinstructor: "Instructor apellidoM apellidoP",
      nombrepatron: "Patron apellidoM apellidoP",
      nombrerepresentante: "Representante apellidoM apellidoP",
      firmainstructor: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Firma_de_Fernando_Mar%C3%ADas.svg/2560px-Firma_de_Fernando_Mar%C3%ADas.svg.png",
      firmapatron: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Firma-Danilo-Medina.svg/1280px-Firma-Danilo-Medina.svg.png",
      firmarepresentante: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Firma_Magario.svg/1280px-Firma_Magario.svg.png",
    }
     
  ]


  ls_selmes(){
    this.ls_sessions('sin_errores');
  }
  
  
  ls_sessions(tpo){
    this.ses = null;
    this.ses = [];
    
    this.USUARIO= null;
    this.Vcurso = null;
    this.VTrainer = null;
    this.Vproveedor = null;


    this.dc4 = false;
    
    this.loading = true;
    this.authService.updFirmas(this.id_sede)
      .then(
        data => { 
          this.loading = false;                

          this.ses = null;
          this.USUARIO= null;

          var sqry;
          sqry = "SET GLOBAL max_connections = 300;";
          this.authService.ejecuta1(sqry)
          .then(
            data33 => { 
              this.loading = false;                

              sqry = " select" +
      " tblempleado.id," +
      " tblempleado.nombre, tblempleado.apaterno,tblempleado.amaterno,tblempleado.curp,tblempleado.rfc," +
      " tblsesion.nombre as sesion,tblcurso.clave as ClaveCurso, tblcurso.nombre as curso,fecinicio,fectermino,duracion," +
      " tblcategoria_ent.nombre as categoria,tbllocacion.nombre as locacion," +
      " tblentrenador.nombre as nomentrenador,tblentrenador.apaterno as patentrenador, tblentrenador.amaterno as matentrenador," +
      " tblentrenador.rfc as rfcentrenador, tblentrenador.firma as firmaentrenador," +
      " tblpuesto.nombre as puesto,tblpuesto.descripcion as ocupacion, tblestacion.nombre as estacion," +
      " 'Proveedor' as proveedor," +
      " tblestado.clave as Estado, municipio as Municipio,tblescolaridad.clave as Estudios,tblinstitucion.clave as Institucion," +
      " tbldocprobatorio.clave as Documento" +
      " from tblsesionempleado" +
      " join tblempleado on (tblsesionempleado.idempleado = tblempleado.id)" +
      " join tblestado on (tblempleado.idestado = tblestado.id)" +
      " join tblescolaridad on (tblempleado.idescolaridad = tblescolaridad.id)" +
      " join tblinstitucion on (tblempleado.idinstitucion = tblinstitucion.id)" +
      " join tbldocprobatorio on (tblempleado.iddocprobatorio = tbldocprobatorio.id)" +      
      " join tblsesion on (tblsesionempleado.idsesion = tblsesion.id)" +
      " join tblcurso on (tblsesion.idcurso = tblcurso.id)" +
      " join tblcategoria_ent on (tblcurso.idcategoria = tblcategoria_ent.id)" +
      " join tbllocacion on (tblsesion.idlocacion = tbllocacion.id)" +
      " join tblentrenador on (tblsesion.identrenador = tblentrenador.id)" +
      " join tblestacionpuestoempleado on (tblempleado.id = tblestacionpuestoempleado.idempleado and tblestacionpuestoempleado.estado = 'A')" +
      " join tblestacionpuesto on (tblestacionpuestoempleado.idestacionpuesto = tblestacionpuesto.id)" +
      " join tblestacion on (tblestacionpuesto.idestacion = tblestacion.id)" +
      " join tblpuesto on (tblestacionpuesto.idpuesto = tblpuesto.id)" +
      " where MONTH(fecinicio) = " + this.selmes.id + 
      " and year(fecinicio) = " + this.selano.id;


          this.loading = true;
          this.authService.ejecuta1(sqry)          
          .then(
              data => {
                this.loading = false;            
                var dat = JSON.stringify(data);
                var res = JSON.parse(dat);              
                if (res.length!=0)
                {
                  var __ses = [];
                  for(var i = 0; i < res.length;i++){
                    __ses.push({ 
                      PersonnelNumber: res[i].id,
                      PrimerApellido: res[i].apaterno,
                      SegundoApellido: res[i].amaterno,
                      Nombre: res[i].nombre,
                      Curp: res[i].curp,
                      Puesto: res[i].puesto,
                      Ocupacion: res[i].ocupacion,
                      CourseName: res[i].curso,
                      Duracion: res[i].duracion,
                      Begin: res[i].fecinicio,
                      End: res[i].fecinicio,
                      Area: res[i].estacion,
                      Trainer: res[i].nomentrenador + ' ' + res[i].patentrenador  + ' ' + res[i].matentrenador,
                      rfc: res[i].rfc,
                      proveedor: res[i].proveedor,              //falta
                      CourseName1: {CourseName: res[i].curso },
                      Trainer1: {Trainer: res[i].nomentrenador + ' ' + res[i].patentrenador  + ' ' + res[i].matentrenador },
                      proveedor1: {proveedor: res[i].proveedor }, //falta
                      Area1: {Area: res[i].estacion },                      
                      Estado: res[i].Estado,
                      Municipio: res[i].Municipio,
                      Estudios: res[i].Estudios,
                      Documento: res[i].Documento,
                      Institucion: res[i].Institucion,                      
                      ClaveCurso: res[i].ClaveCurso,
                      Rfc: res[i].rfc,
                      
                    });
                  }
                  this.ses = __ses;   
                  
                  var acurso = __ses.reduce( (a,b) => {
                    var i = a.findIndex( x => x.CourseName === b.CourseName);      
                    return i === -1 ? a.push({ CourseName : b.CourseName}) : 0, a;
                  }, []);   
                  acurso = _.sortBy(acurso, 'CourseName');                    
                  this.Vcurso = acurso
                  

                  var atrainer = __ses.reduce( (a,b) => {
                    var i = a.findIndex( x => x.Trainer === b.Trainer);      
                    return i === -1 ? a.push({ Trainer : b.Trainer}) : 0, a;
                  }, []);   
                  atrainer = _.sortBy(atrainer, 'Trainer');                    
                  this.VTrainer = atrainer

                  
                  var aproveedor = __ses.reduce( (a,b) => {
                    var i = a.findIndex( x => x.proveedor === b.proveedor);      
                    return i === -1 ? a.push({ proveedor : b.proveedor}) : 0, a;
                  }, []);   
                  aproveedor = _.sortBy(aproveedor, 'proveedor');                    
                  this.Vproveedor = aproveedor

                  var aArea = __ses.reduce( (a,b) => {
                    var i = a.findIndex( x => x.Area === b.Area);      
                    return i === -1 ? a.push({ Area : b.Area}) : 0, a;
                  }, []);   
                  aArea = _.sortBy(aArea, 'Area');                    
                  this.VArea = aArea

                            
                  var _sesA = [];
                  for(var i = 0; i < res.length;i++){
                    var Trainer = res[i].Trainer;
                    if (Trainer =="") Trainer = " ";              
                    _sesA.push({ 
                      apellidoP:" ",
                      apellidoM:" ",
                      nombre: res[i].PersonnelName,
                      SHCPT: res[i].Curp,
                      ocupacion: res[i].Puesto,
                      Puesto: res[i].Puesto,
                      nombreE:"TRINITY RAIL DE MEXICO S. DE R.L. DE C.V.",
                    //SHCPTE:"MEGS950718940",
                      SHCPTE:"TRM041203EI8",
                      IMSS:"Y2345678901",
                      actividad:"DOMAR LEONES",
                      nombreP: res[i].CourseName,
                      duracion: res[i].TotalEnrolled,
                      anioI:"95",
                      mesI:"07",
                      diaI:"18",
                      anioF:"95",
                      mesF:"97",
                      diaF:"18",
                      nombreC:"maestro",
                      nombreI: Trainer,

                      rfc: res[i].rfc,
                      proveedor: res[i].proveedor

                    });

                  }
                  this.USUARIO = _sesA;     
                  this.ls_firmas();                     
                }
                else
                {            
                  //swal.fire('No existe información!', '', 'info');            
                }
              },
              error => {
                  this.loading = false;
                  var de= JSON.stringify(error);
                  var di = JSON.parse(de)
                  swal.fire('¡Información incorrecta!1', '', 'error');
              });   
              


          },
          error33 => {
            this.loading = false;
            var de= JSON.stringify(error33);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!2', '', 'error');
        });
      },
      error => {
        this.loading = false;
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!3', '', 'error');
    });
  }

   

  winfir = false;
  fir;
  ls_firmas(){
    this.pnlmensaje = false;
    this.loading = true;              
    this.authService.firmas(this.id_sede).then(
      data => {
        this.loading = false;            
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat); 
        if (res.length!=0){
          var _fir = [];   
          //this.table1.first = 0;       
          for(var i = 0; i < res.length;i++){
            var stpo = "";
            switch (res[i].tipo){
              case 'i':
                stpo = "Instructor";
                break;      
              case 'r':             
                stpo = "Patron o representante legal";   
                break;      
              case 't':                
                stpo = "Representante de los trabajadores";   
                break;      
            }
            var stienefirma = "No";
            var sfirma = 'http://5.183.8.170:3002/sinfirma.jpeg';
            var sfirman = "sinfirma.jpeg";
            if (res[i].firma!=""){
              stienefirma = "Si";
              sfirma = 'http://5.183.8.170:3002/' + res[i].firma;
              sfirman = res[i].firma;
            }

            var bIns = false;
            if (res[i].tipo == 'i'){
              var objIndex = this.ses.findIndex(((itm :any) => itm.Trainer == res[i].trainer));    
              if (objIndex!=-1) bIns = true;
            }
            else{
              bIns = true;
            }
            if (bIns){
              _fir.push({ 
                id: res[i].id,
                trainer: res[i].trainer,
                tipo: stpo,
                tipo1:res[i].tipo,
                tienefirma: stienefirma,
                firma: sfirma,
                firmab: res[i].firmab,
                firman: sfirman
              });
            }
          }
          this.fir = _fir;    
        }
      },
      error => {
          this.loading = false;
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!4', '', 'error');
      }
    );  
  }
   

  URL: any;
  pnlmensaje = false;
  uploadIamgen(event,itm) {  
  }

 
 
  showSplash = false;
  Pgg3_A(){
    this.Pgg3();
    this.showSplash = true;
  
    var exporta;
    if (this.table.filteredValue == null)
      exporta = this.table.value;
    else
      exporta = this.table.filteredValue;
  
    var b = 0;
    var i = exporta.length;
  
    if (i >= 1000) {
      b = 35000;
    } else {
      b = ((35000 * i) / 1000);
    }
    timer(b).subscribe(() => {
      this.showSplash = false;
    });
  }

  async Pgg3() {

    var exporta;
    if (this.table.filteredValue == null)
      exporta = this.table.value;
    else
      exporta = this.table.filteredValue;
  
      var _sesA = []   
  
      //for (let i = 0; i < 1; i++) {
      for (let i = 0; i < exporta.length; i++) {
        
        var Trainer = exporta[i].Trainer;
        var Trainer1 = exporta[i].Nombre.toString() + " " + exporta[i].PrimerApellido.toString() + " " + exporta[i].SegundoApellido.toString();
  
  
        var firmainstructor;
        var objIndex = this.fir.findIndex(((itm :any) => itm.trainer == Trainer));    
              
        if (objIndex!=-1){        
          firmainstructor = this.fir[objIndex].firmab;
        }
        if (firmainstructor==undefined){  
          firmainstructor = "assets/img/sinfirma.jpeg";
        }
  
        var firmapatron;
        var nombrepatron;
        objIndex = this.fir.findIndex(((itm :any) => itm.tipo1 == 'r'));    
        if (objIndex!=-1){
          firmapatron = this.fir[objIndex].firmab;
          nombrepatron= this.fir[objIndex].trainer;
        }
        if (firmapatron==undefined){  
          firmapatron = "assets/img/sinfirma.jpeg";
        }
  
        var firmarepresentante;
        var nombrerepresentante;
        objIndex = this.fir.findIndex(((itm :any) => itm.tipo1 == 't'));    
        if (objIndex!=-1){
          firmarepresentante = this.fir[objIndex].firmab;
          nombrerepresentante= this.fir[objIndex].trainer;
        }
        if (firmarepresentante==undefined){  
          firmarepresentante = "assets/img/sinfirma.jpeg";
        }
  
        var sfecha1 = '';
        var ssdia1;
        var ssmes1;
        var ssaño1;
  
        if (exporta[i].Begin != ''){
          var dfecha1 = new Date(exporta[i].Begin)      
          
          let sdia1 = dfecha1.getDate();
          let smes1 = dfecha1.getMonth() + 1;
          let saño1 = dfecha1.getFullYear();
          
          ssdia1 = sdia1.toString();
          if (ssdia1.length == 1)
            ssdia1 = '0' + ssdia1;
          ssmes1 = smes1.toString();
          if (ssmes1.length == 1)
            ssmes1 = '0' + ssmes1;
          ssaño1 = saño1.toString();
          ssaño1 = ssaño1.substring(2,4)
          sfecha1 = ssdia1 + "/" + ssmes1  + "/" + saño1
        }
        var sfecha2 = '';
        var ssdia2;
        var ssmes2;
        var ssaño2;
        if (exporta[i].End != ''){
          var dfecha2 = new Date(exporta[i].End)      
          let sdia2 = dfecha2.getDate();
          let smes2 = dfecha2.getMonth() + 1;
          let saño2 = dfecha2.getFullYear();
  
          ssdia2 = sdia2.toString();
          if (ssdia2.length == 1)
            ssdia2 = '0' + ssdia2;
          ssmes2 = smes2.toString();
          if (ssmes2.length == 1)
            ssmes2 = '0' + ssmes2;
          ssaño2 = saño2.toString();
          ssaño2 = ssaño2.substring(2,4)
          sfecha2 = ssdia2 + "/" + ssmes2  + "/" + saño2
        }
        
        var sOcupacion  =  "";
        if (exporta[i].Ocupacion != null){
          sOcupacion = exporta[i].Ocupacion;
          var n = sOcupacion.indexOf(" ");  
          sOcupacion = sOcupacion.substring(0,n);   
        }
        
        
        let dur =  Math.floor(exporta[i].Duracion);
        if (exporta[i].Duracion < 1)
            dur = 1;        
  
        var sArea = " ";
        if (exporta[i].Area != null){
          sArea = exporta[i].Area;
        }
  
        if (Trainer =="") Trainer = " ";              
        _sesA.push({ 
          apellidoP: exporta[i].PrimerApellido,
          apellidoM: exporta[i].SegundoApellido,
          nombre: exporta[i].Nombre,
          SHCPT: exporta[i].Curp,
          Puesto: exporta[i].Puesto,
          ocupacion: sOcupacion,
          nombreE:this.razon,      
          SHCPTE: this.rfc,
          IMSS:"Y2345678901",
          actividad:"ACTIVIDAD",
          nombreP: exporta[i].CourseName,
          duracion: dur,
          anioI: ssaño1,
          mesI: ssmes1,
          diaI: ssdia1,
          anioF: ssaño2,
          mesF: ssmes2,
          diaF: ssdia2,
          nombreC: exporta[i].proveedor + ' Num. de Registro. ' +  exporta[i].rfc,
          nombreI: sArea,
  
  
  
          nombreinstructor: Trainer,
          nombrepatron: nombrepatron,
          nombrerepresentante: nombrerepresentante,
          
          //firmainstructor: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Firma_de_Fernando_Mar%C3%ADas.svg/2560px-Firma_de_Fernando_Mar%C3%ADas.svg.png",
          //firmapatron: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Firma-Danilo-Medina.svg/1280px-Firma-Danilo-Medina.svg.png",
          //firmarepresentante: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Firma_Magario.svg/1280px-Firma_Magario.svg.png",
  
          
          firmainstructor: firmainstructor,
          firmapatron: firmapatron,
          firmarepresentante: firmarepresentante,
          
        });
      }
      this.USUARIO = _sesA; 
      
    const meta = this.USUARIO.length  
    var contador=0;
  
        const pdf = new PdfMakeWrapper();
        pdf.pageSize('letter');
          
        for    (const usu of this.USUARIO) {
                   
                        
        
                     
          //pdf.add( await new Img('/assets/img/logo.png').fit([150, 150]).alignment('right').build());
  
          pdf.add(new Txt('FORMATO DC-3\n').alignment('center').fontSize(13).end);
          pdf.add(new Txt('CONSTANCIA DE HABILIDADES LABORALES').alignment('center').fontSize(13).end);
  
          pdf.add(new Txt('                                                            DATOS DEL TRABAJADOR                                                              ').alignment('center').background('#353a40').color('white').fontSize(13).end);
          pdf.add(new Txt('Nombre (Anotar apellido paterno, apellido materno y nombre(s))').fontSize(10).end);
  
          pdf.add(new Txt(usu.apellidoP + ' ' + usu.apellidoM + ' ' + usu.nombre).color('#848a8f').fontSize(10).end);
  
          pdf.add('\n');
          pdf.add(new Columns(['Clave Única de Registro de Población', 'Ocupación especifica(Catálogo Nacional de Ocupaciones)¹']).fontSize(10).end);
          pdf.add(new Columns(['          ' + usu.SHCPT[0] + '     ' + usu.SHCPT[1] + '     ' + usu.SHCPT[2] + '     ' + usu.SHCPT[3] + '    -    ' + usu.SHCPT[4] + '      ' + usu.SHCPT[5] + '     ' + usu.SHCPT[6] + '     ' + usu.SHCPT[7] + '     ' + usu.SHCPT[8] + '     ' + usu.SHCPT[9] + '    -    ' + usu.SHCPT[10] + '     ' + usu.SHCPT[11] + '      ' + usu.SHCPT[12], usu.ocupacion]).color('#848a8f').fontSize(10).end);
          pdf.add(new Txt('Puesto*').fontSize(10).end);
  
          pdf.add(new Txt(usu.Puesto).color('#848a8f').fontSize(10).end);
          pdf.add('\n');
          pdf.add(new Txt('                                                              DATOS DE LA EMPRESA                                                                ').alignment('center').background('#353a40').color('white').fontSize(13).end);
  
          pdf.add(new Txt('Nombre o razón social(En caso de persona fisica, anotar apellido paterno, apellido materno y nombre(s))').fontSize(10).end);
          pdf.add(new Txt(usu.nombreE).color('#848a8f').fontSize(10).end);
          pdf.add('\n');
          pdf.add(new Columns(['Registro Federal de Contribuyentes (SHCP)', '']).fontSize(10).end);
          pdf.add(new Columns(['           ' + usu.SHCPTE[0] + '     ' + usu.SHCPTE[1] + '     ' + usu.SHCPTE[2] + '      ' + usu.SHCPTE[3] + '     -    ' + usu.SHCPTE[4] + '      ' + usu.SHCPTE[5] + '     ' + usu.SHCPTE[6] + '     ' + usu.SHCPTE[7] + '     ' + usu.SHCPTE[8] + '     ' + usu.SHCPTE[9] + '   -   ' + usu.SHCPTE[10] + '     ' + usu.SHCPTE[11], '']).color('#848a8f').fontSize(10).end);
          pdf.add('\n');
  
          pdf.add('\n');
          pdf.add(new Txt('                         DATOS DEL PROGRAMA DE CAPACITACION Y ADIESTRAMIENTO                            ').alignment('center').background('#353a40').color('white').fontSize(13).end);
  
          pdf.add(new Txt('Nombre del  curso').fontSize(10).end);
          pdf.add(new Txt(usu.nombreP).color('#848a8f').fontSize(8).end);
          pdf.add('\n');
  
          //    pdf.add(new Table([
  
          //    [ 'Duración en horas','Periodo de ejecución', 'Año  Mes  Dia','Año  Mes  Dia'] 
          //  ]).widths([ '*',150, 100 ,130]).layout('noBorders').fontSize(10).end);
          pdf.add(new Table([
            ['Duración en horas', 'Periodo de ejecución:', 'Año', 'Mes', 'Día', 'Año', 'Mes', 'Día']
          ]).widths(['*', 130, 20, 20, 38, 20, 20, 86]).layout('noBorders').fontSize(10).end);
          pdf.add(new Columns([usu.duracion, 'De   ' + '  ' + usu.anioI[0] + '   ' + usu.anioI[1] + '   ' + usu.mesI[0] + '   ' + usu.mesI[1] + '   ' + usu.diaI[0] + '   ' + usu.diaI[1] + '     a     ' + usu.anioF[0] + '   ' + usu.anioF[1] + '   ' + usu.mesF[0] + '   ' + usu.mesF[1] + '   ' + usu.diaF[0] + '   ' + usu.diaF[1] + '   ']).color('#848a8f').fontSize(10).end);
          pdf.add('\n');
          pdf.add(new Txt('Área temática del curso²').fontSize(10).end);        
          pdf.add(new Txt(usu.nombreI).color('#848a8f').fontSize(10).end);//checar
          pdf.add('\n');
          pdf.add(new Txt('Nombre del agente capacitador o1 STPS³').fontSize(10).end);
          pdf.add(new Txt(usu.nombreC).color('#848a8f').fontSize(10).end);
          pdf.add('\n');
          pdf.add(new Txt('Los datos se asientan en esta constancia bajo protesta de decir la verdad, apercibidos de la responsabilidad en que incurre todo aquel que no se conduce con la verdad.').fontSize(11).bold().alignment('center').end);
          pdf.add('\n');
         
   
          pdf.add(new Columns(['Instructor o tutor', 'Patrón o representante legal⁴', 'Representante de los trabajadores']).fontSize(10).alignment('center').end);
          //pdf.add(new Columns([ 'ante la comisión mixta de capacitación', 'ante la comisión mixta de capacitación' ]).fontSize(10).alignment('center').end);
          //  pdf.add(new Table([
          //   [ img2,img3, img4,] 
          // ]).layout('noBorders').alignment('center').end);
          var  a= new Txt('5').fontSize(6).relativePosition(519,-11).end;
  
          
          pdf.add(a);
          pdf.add(new Columns([await new Img(usu.firmainstructor).fit([40, 40]).build(), await new Img(usu.firmapatron).fit([40, 40]).build(), await new Img(usu.firmarepresentante).fit([40, 40]).build()]).alignment('center').end);
  
          pdf.add(new Columns([usu.nombreinstructor  , usu.nombrepatron, usu.nombrerepresentante]).fontSize(8).alignment('center').color('#848a8f').end);
          pdf.add(new Columns(['Nombre y firma', 'Nombre y firma', 'Nombre y firma']).fontSize(10).alignment('center').end);
          pdf.add('\n');
          pdf.add(new Txt('INSTRUCCIONES').fontSize(13).bold().end);
          pdf.add('\n');
          pdf.add(new Ul([
            'Llenar a maquina o con letra molde.',
            'Deberá entregarse al trabajador dentro de los veinte días hábiles siguientes al término del curso de capacitación aprobado.'
  
          ]).fontSize(8).end);
          pdf.add(new Ol([
            'Las áreas y subáreas ocupacionales del Catálogo Nacional de Ocupaciones se encuentran disponibles en el reverso de este formato y en la página www.stps.gob.mx ',
            'Las áreas temáticas de los cursos se encuentran disponibles en el reverso de este formato y en la página www.stps.gob.mx ',
            'Cursos impartidos por el área competente de la Secretaria del Trabajo y Previsión Social.',
            'Para empresas con menos de 51 trabajadores. Para empresas con más de 50 trabajadores firmaría el representante del patrón ante la Comisión mixta de capacitación, adiestramiento y productividad.',
            'Solo para empresas con más de 50 trabajadores.',
  
  
          ]).fontSize(8).end);
          pdf.add(new Txt('* Dato no obligatorio').fontSize(8).end);
          // pdf.add(new Txt('Consultas sobre el trámite llamar a la Dirección General de Capacitación al Teléfono 3000-3500 extensión 3526.').fontSize(8).end);
          // pdf.add(new Txt('Para quejas comunicarse al número telefónico del Órgano Interno de Control en la STPS al (55) 56-44-74-15.\n\n').fontSize(8).end);
  
          pdf.add(new Txt('DC-3 ANVERSO').alignment('right').fontSize(10).end);
         
          pdf.add({
            canvas: [
              //  { type: 'line', x1: -3, y1: -650, x2: 510, y2: -200, lineWidth: 1 }, // datos del trabajador
              { type: 'line', x1: -2, y1: -533, x2: 541, y2: -533, lineWidth: 1 }, //Bottom line
              { type: 'line', x1: -2, y1: -619, x2: -2, y2: -533, lineWidth: 1 }, //Left line
              { type: 'line', x1: 541, y1: -619, x2: 541, y2: -533, lineWidth: 1 }, //Rigth line
              // datos de la empresa 
              { type: 'line', x1: -2, y1: -440, x2: 541, y2: -440, lineWidth: 1 }, //Bottom line
              { type: 'line', x1: -2, y1: -506, x2: -2, y2: -440, lineWidth: 1 }, //Left line
              { type: 'line', x1: 541, y1: -506, x2: 541, y2: -440, lineWidth: 1 }, //Rigth line
  
              // datos del programa 
              { type: 'line', x1: -2, y1: -262, x2: 541, y2: -262, lineWidth: 1 }, //Bottom line
              { type: 'line', x1: -2, y1: -402, x2: -2, y2: -262, lineWidth: 1 }, //Left line
              { type: 'line', x1: 541, y1: -402, x2: 541, y2: -262, lineWidth: 1 }, //Rigth line
              // last
              { type: 'line', x1: -2, y1: -252, x2: 541, y2: -252, lineWidth: 1 },//up line
              { type: 'line', x1: -2, y1: -140, x2: 541, y2: -140, lineWidth: 1 }, //Bottom line
              { type: 'line', x1: -2, y1: -252, x2: -2, y2: -140, lineWidth: 1 }, //Left line
              { type: 'line', x1: 541, y1: -252, x2: 541, y2: -140, lineWidth: 1 }, //Rigth line
  
              // internas datos del trabajador
              { type: 'line', x1: -2, y1: -590, x2: 541, y2: -590, lineWidth: 1 }, //horizontal line
              { type: 'line', x1: -2, y1: -559, x2: 541, y2: -559, lineWidth: 1 }, //horizontal line
              { type: 'line', x1: 260, y1: -590, x2: 260, y2: -559, lineWidth: 1 }, //vertical line
              // internas datos del empresa
              { type: 'line', x1: -2, y1: -475, x2: 541, y2: -475, lineWidth: 1 }, //horizontal line
  
  
              // internas datos del programa
              { type: 'line', x1: -2, y1: -375, x2: 541, y2: -375, lineWidth: 1 }, //horizontal line
              { type: 'line', x1: -2, y1: -335, x2: 541, y2: -335, lineWidth: 1 }, //horizontal line2
              { type: 'line', x1: -2, y1: -295, x2: 541, y2: -295, lineWidth: 1 }, //horizontal line3
              { type: 'line', x1: 110, y1: -375, x2: 110, y2: -335, lineWidth: 1 }, //vertical line
  
              // shcp1
              { type: 'line', x1: 13, y1: -570, x2: 13, y2: -559, lineWidth: 1 },
              { type: 'line', x1: 33, y1: -570, x2: 33, y2: -559, lineWidth: 1 },
              { type: 'line', x1: 53, y1: -570, x2: 53, y2: -559, lineWidth: 1 },
              { type: 'line', x1: 68, y1: -570, x2: 68, y2: -559, lineWidth: 1 },
              { type: 'line', x1: 83, y1: -570, x2: 83, y2: -559, lineWidth: 1 },
              { type: 'line', x1: 100, y1: -570, x2: 100, y2: -559, lineWidth: 1 },
              { type: 'line', x1: 120, y1: -570, x2: 120, y2: -559, lineWidth: 1 },
              { type: 'line', x1: 138, y1: -570, x2: 138, y2: -559, lineWidth: 1 },
              { type: 'line', x1: 158, y1: -570, x2: 158, y2: -559, lineWidth: 1 },
              { type: 'line', x1: 176, y1: -570, x2: 176, y2: -559, lineWidth: 1 },
              { type: 'line', x1: 190, y1: -570, x2: 190, y2: -559, lineWidth: 1 },
              { type: 'line', x1: 205, y1: -570, x2: 205, y2: -559, lineWidth: 1 },
              { type: 'line', x1: 220, y1: -570, x2: 220, y2: -559, lineWidth: 1 },
              { type: 'line', x1: 237, y1: -570, x2: 237, y2: -559, lineWidth: 1 },
              // shcp2
              { type: 'line', x1: 13, y1: -455, x2: 13, y2: -440, lineWidth: 1 },
              { type: 'line', x1: 33, y1: -455, x2: 33, y2: -440, lineWidth: 1 },
              { type: 'line', x1: 53, y1: -455, x2: 53, y2: -440, lineWidth: 1 },
              { type: 'line', x1: 68, y1: -455, x2: 68, y2: -440, lineWidth: 1 },
              { type: 'line', x1: 83, y1: -455, x2: 83, y2: -440, lineWidth: 1 },
              { type: 'line', x1: 100, y1: -455, x2: 100, y2: -440, lineWidth: 1 },
              { type: 'line', x1: 120, y1: -455, x2: 120, y2: -440, lineWidth: 1 },
              { type: 'line', x1: 138, y1: -455, x2: 138, y2: -440, lineWidth: 1 },
              { type: 'line', x1: 158, y1: -455, x2: 158, y2: -440, lineWidth: 1 },
              { type: 'line', x1: 176, y1: -455, x2: 176, y2: -440, lineWidth: 1 },
              { type: 'line', x1: 190, y1: -455, x2: 190, y2: -440, lineWidth: 1 },
              { type: 'line', x1: 203, y1: -455, x2: 203, y2: -440, lineWidth: 1 },
              { type: 'line', x1: 216, y1: -455, x2: 216, y2: -440, lineWidth: 1 },
              { type: 'line', x1: 237, y1: -455, x2: 237, y2: -440, lineWidth: 1 },
             // { type: 'line', x1: 257, y1: -460, x2: 257, y2: -445, lineWidth: 1 },
  
              //fecha
              { type: 'line', x1: 284, y1: -350, x2: 284, y2: -335, lineWidth: 1 },
              { type: 'line', x1: 300, y1: -350, x2: 300, y2: -335, lineWidth: 1 },
              { type: 'line', x1: 313, y1: -350, x2: 313, y2: -335, lineWidth: 1 },
              { type: 'line', x1: 326, y1: -350, x2: 326, y2: -335, lineWidth: 1 },
              { type: 'line', x1: 339, y1: -350, x2: 339, y2: -335, lineWidth: 1 },
              { type: 'line', x1: 352, y1: -350, x2: 352, y2: -335, lineWidth: 1 },
              { type: 'line', x1: 365, y1: -350, x2: 365, y2: -335, lineWidth: 1 },
              { type: 'line', x1: 385, y1: -350, x2: 385, y2: -335, lineWidth: 1 },
              { type: 'line', x1: 401, y1: -350, x2: 401, y2: -335, lineWidth: 1 },
              { type: 'line', x1: 414, y1: -350, x2: 414, y2: -335, lineWidth: 1 },
              { type: 'line', x1: 427, y1: -350, x2: 427, y2: -335, lineWidth: 1 },
              { type: 'line', x1: 440, y1: -350, x2: 440, y2: -335, lineWidth: 1 },
              { type: 'line', x1: 453, y1: -350, x2: 453, y2: -335, lineWidth: 1 },
              { type: 'line', x1: 466, y1: -350, x2: 466, y2: -335, lineWidth: 1 },
              //firma
              { type: 'line', x1: 20, y1: -160, x2: 160, y2: -160, lineWidth: 1 }, //horizontal line
              { type: 'line', x1: 380, y1: -160, x2: 520, y2: -160, lineWidth: 1 }, //horizontal line
              { type: 'line', x1: 200, y1: -160, x2: 340, y2: -160, lineWidth: 1 }, //horizontal line
            
  
            ]
  
            
            
          });
          pdf.add(new Txt('CLAVES Y DENOMINACIONES DE ÁREAS Y SUBÁREAS DEL CATÁLOGO NACIONAL DE OCUPACIONES').alignment('center').fontSize(10).bold().end);
  
          pdf.add(new Table([
            ['CLAVE DEL ÁREA/SUBÁREA', 'DENOMINACIÓN', 'CLAVE DEL ÁREA/SUBÁREA', 'DENOMINACIÓN']
          ]).widths([80, '*', 80, '*']).layout('noBorders').fontSize(10).bold().alignment('center').end);
  
          pdf.add(new Table([
            ['01', 'Cultivo, crianza y aprovechamiento', '06', 'Transporte'],
            ['01.1', 'Agricultura y silvicultura', '06.1', 'Ferroviario'],
            ['01.2', 'Ganadería', '06.2', 'Autotransporte'],
            ['01.3', 'Pesca y acuacultura', '06.3', 'Aéreo'],
            ['', '', '06.4', 'Marítimo y fluvial'],
            ['02', 'Extracción y suministro', '06.5', 'Servicios de apoyo'],
            ['02.1', 'Exploración', '', ''],
            ['02.2', 'Extracción', '07', 'Provisión de bienes y servicios'],
            ['02.3', 'Refinación y beneficio', '07.1', 'Comercio'],
            ['02.4', 'Provisión de energía', '07.2', 'Alimentación y hospedaje'],
            ['02.5', 'Provisión de agua', '07.3', 'Turismo'],
            ['', '', '07.4', 'Deporte y esparcimiento'],
            ['03', 'Construcción', '07.5', 'Servicios personales'],
            ['03.1', 'Planeación y dirección de obras', '07.6', 'Reparación de artículos de uso doméstico y personal'],
            ['03.2', 'Edificación y urbanización', '07.7', 'Limpieza'],
            ['03.3', 'Acabado', '07.8', 'Servicio postal y mensajería'],
            ['03.4', 'Instalación y mantenimiento', '', ''],
            ['', '', '08', 'Gestión y soporte administrativo'],
            ['04', 'Tecnología', '08.1', 'Bolsa, banca y seguros'],
            ['04.1', 'Mecánica', '08.2', 'Administración'],
            ['04.2', 'Electricidad', '08.3', 'Servicios legales'],
            ['04.3', 'Electrónica', '', ''],
            ['04.4', 'Informática', '09', 'Salud  y protección social'],
            ['04.5', 'Telecomunicaciones', '09.1', 'Servicios médicos'],
            ['04.6', 'Procesos industriales', '09.2', 'Inspección sanitaria y del medio ambiente'],
            ['', '', '09.3', 'Seguridad social'],
            ['05', 'Procesamiento y fabricación', '09.4', 'Protección de bienes y/o personas'],
            ['05.1', 'Minerales no metálicos', '', ''],
            ['05.2', 'Metales', '10', 'Comunicación'],
            ['05.3', 'Alimentos y bebidas', '10.1', 'Publicación'],
            ['05.4', 'Textiles y prendas de vestir', '10.2', 'Radio, cine, televisión y teatro'],
            ['05.5', 'Materia orgánica', '10.3', 'Interpretación artística'],
            ['05.6', 'Productos químicos', '10.4', 'Traducción e interpretación lingüística'],
            ['05.7', 'Productos metálicos y de hule y plástico', '10.5', 'Publicidad, propaganda y relaciones públicas'],
            ['05.8', 'Productos eléctricos y electrónicos', '', ''],
            ['05.9', 'Productos impresos', '11', 'Desarrollo y extensión del conocimiento'],
            ['', '', '11.1', 'Investigación'],
            ['', '', '11.2', 'Enseñanza'],
            ['', '', '11.3', 'Difusión cultural']
  
          ]).widths([80, '*', 80, '*']).layout('noBorders').fontSize(8).end);
  
          pdf.add(new Txt('CLAVES Y DENOMINACIONES DEL CATÁLOGO DE ÁREAS TEMÁTICAS DE LOS CURSOS').alignment('center').fontSize(10).bold().end);
          pdf.add('\n');
          pdf.add(new Table([
            ['CLAVE DEL ÁREA', 'DENOMINACIÓN', 'CLAVE DEL ÁREA', 'DENOMINACIÓN']
          ]).widths([80, '*', 80, '*']).layout('noBorders').fontSize(10).bold().alignment('center').end);
          pdf.add(new Table([
            ['1000', 'Producción general', '6000', 'Seguridad'],
            ['2000', 'Servicios', '7000', 'Desarrollo personal y familiar'],
            ['3000', 'Administración, contabilidad y economía', '8000', 'Uso de tecnologías de la información y  comunicación'],
            ['4000', 'Comercialización', '9000', 'Participación social'],
            ['5000', 'Mantenimiento y reparación', '', ''],
  
  
          ]).widths([80, '*', 80, '*']).layout('noBorders').fontSize(8).end);
  
          pdf.add(new Txt('DC-3 REVERSO').alignment('right').fontSize(10).end);
   
  
     
       
  
  }
      pdf.create().download('DC3 - ' + this.mes[this.selmes.id - 1].nombre);    
    }
  

    dc4 = false;  
    ls_sessionsDC4(tpo){
      this.dc4 = true;  
      this.ses = null;
      this.USUARIO= null;


      var sqry;
      sqry = " select" +  
      " tblempleado.curp as Curp,tblempleado.nombre as Nombre, tblempleado.apaterno as PrimerApellido,tblempleado.amaterno as SegundoApellido," +
      " tblestado.clave as ClaveEstado, tblempleado.municipio as ClaveMunicipio, tblpuesto.descripcion as ClaveOcupacion," +
      " tblescolaridad.clave as ClaveNivEstudios, tbldocprobatorio.clave as ClaveDocProbatorio,tblinstitucion.clave as ClaveInstitucion," +
      " tblcurso.clave as ClaveCurso, tblcurso.nombre as CourseName, 1 as ClaveAreaTematica, tblsesion.duracion as Duracion," +
      " tblsesion.fecinicio as `Begin`, tblsesion.fectermino as `End`, 1 as ClaveTipAgente, 'XXXXXXXXXXXXX' as RfcAgente," +
      " 1 as ClaveModalidad, 1 as ClaveCapacitacion, 1 ClaveEstablecimiento," +
      " CONCAT(tblentrenador.nombre, ' ', tblentrenador.apaterno, ' ', tblentrenador.amaterno) AS Trainer" +
      " from tblempleado" +
      " join tblestado on (tblempleado.idestado = tblestado.id)" +
      " join tblestacionpuestoempleado on (tblempleado.id = tblestacionpuestoempleado.idempleado and tblestacionpuestoempleado.estado = 'A')" +
      " join tblestacionpuesto on (tblestacionpuestoempleado.idestacionpuesto = tblestacionpuesto.id)" +
      " join tblpuesto on (tblestacionpuesto.idpuesto = tblpuesto.id)" +
      " join tblescolaridad on (tblempleado.idescolaridad = tblescolaridad.id)" +
      " join tbldocprobatorio on (tblempleado.iddocprobatorio = tbldocprobatorio.id)" +
      " join tblinstitucion on (tblempleado.idinstitucion = tblinstitucion.id)" +
      " join tblsesionempleado on (tblsesionempleado.idempleado = tblempleado.id)" +
      " join tblsesion on (tblsesionempleado.idsesion = tblsesion.id)" +
      " join tblcurso on (tblsesion.idcurso = tblcurso.id)" +
      " join tblentrenador on (tblsesion.identrenador = tblentrenador.id)" +
      " where MONTH(tblsesion.fecinicio) = " + this.selmes.id + 
      " and year(tblsesion.fecinicio) = " + this.selano.id;

      this.loading = true;              
      this.authService.ejecuta1(sqry)
      .then(
          data => {
            this.loading = false;            
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0){
              this.ses = data;    
            }
            else
            {            
              //swal.fire('No existe información!', '', 'info');            
            }
          },
          error => {
              this.loading = false;
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡Información incorrecta!5', '', 'error');
          });   
  
    }
    

    exportExcel() {
      import("xlsx").then(xlsx => {
        var Heading = [
          [
            "Trained Date","Course Title","Personnel Name","NOMIX","CURP","Group","Hours","DURACION",
            "CLAVE ESTADO","CLAVE MUNICIPIO","CLAVE NIVEL DE ESTUDIOS","CLAVE DE DOCUMENTO","CLAVE INSTITUCION","CLAVE CURSO","CLAVE AREA TEMÁTICA","CLAVE TIPO AGENTE","RFC"],
        ];      
        const ws = xlsx.utils.book_new();
        xlsx.utils.sheet_add_aoa(ws, Heading);
  
        var exporta;
        if (this.table.filteredValue == null)
          exporta = this.table.value;
        else
          exporta = this.table.filteredValue;

          var _exp = []   
  
          for (let i = 0; i < exporta.length; i++) {
            _exp.push({ 
              End: exporta[i].End,
              CourseName: exporta[i].CourseName,
              PersonnelName: exporta[i].Nombre + ' ' + exporta[i].PrimerApellido + ' ' + exporta[i].SegundoApellido,
              PersonnelNumber: exporta[i].PersonnelNumber,
              Curp: exporta[i].Curp,
              Group: 'Grupo',
              TotalEnrolled: 4,
              Duracion: exporta[i].Duracion,              
              Estado: exporta[i].Estado,
              Municipio: exporta[i].Municipio,
              Estudios: exporta[i].Estudios,
              Documento: exporta[i].Documento,
              Institucion: exporta[i].Institucion,
              ClaveCurso: exporta[i].ClaveCurso,
              Agente: exporta[i].Agente,
              Tema: exporta[i].Tema,
              Rfc: exporta[i].Rfc
            });
          }
  
        const worksheet = xlsx.utils.sheet_add_json(ws, _exp, { origin: 'A2', skipHeader: true });
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, 'DC3 - ' + this.mes[this.selmes.id - 1].nombre);        
      });
    }

    exportExcelDC4() {
      import("xlsx").then(xlsx => {
        var Heading = [
          [
            "CURP", "NOMBRE", "PRIMER APELLIDO", "SEGUNDO APELLIDO", "CLAVE ESTADO", "CLAVE MUNICIPIO",
            "CLAVE OCUPACION", "CLAVE NIV ESTUDIOS", "CLAVE DOC PROBATORIO", "CLAVE INSTITUCION", "CLAVE CURSO",
            "NOMBRE CURSO", "CLAVE AREA TEMATICA", "DURACION", "FEC INICIO", "FEC TERMINO",
            "CLAVE TIP AGENTE", "RFC AGENTE STPS", "CLAVE MODALIDAD", "CLAVE CAPACITACION",
            "CLAVE ESTABLECIMIENTO","ENTRENADOR"
          ]
        ]; 
        
        const ws = xlsx.utils.book_new();
        xlsx.utils.sheet_add_aoa(ws, Heading);
  
        var exporta;
        if (this.table4.filteredValue == null)
          exporta = this.table4.value;
        else
          exporta = this.table4.filteredValue;
          
          
        var _exp = []   
        for (let i = 0; i < exporta.length; i++) {
          
          var Begin =  exporta[i].Begin;
          var End =  exporta[i].End;
          
          var sfecha1 = '';
          if (Begin != ''){
            var dfecha1 = new Date(Begin)      
            let sdia1 = dfecha1.getDate();
            let smes1 = dfecha1.getMonth() + 1;
            let saño1 = dfecha1.getFullYear();
            
            var ssdia1 = sdia1.toString();
            if (ssdia1.length == 1)
              ssdia1 = '0' + ssdia1;
            var ssmes1 = smes1.toString();
            if (ssmes1.length == 1)
              ssmes1 = '0' + ssmes1;
  
            sfecha1 = ssdia1 + "/" + ssmes1  + "/" + saño1
          }
          var sfecha2 = '';
          if (End != ''){
            var dfecha2 = new Date(End)      
            let sdia2 = dfecha2.getDate();
            let smes2 = dfecha2.getMonth() + 1;
            let saño2 = dfecha2.getFullYear();
  
            var ssdia2 = sdia2.toString();
            if (ssdia2.length == 1)
              ssdia2 = '0' + ssdia2;
            var ssmes2 = smes2.toString();
            if (ssmes2.length == 1)
              ssmes2 = '0' + ssmes2;
  
            sfecha2 = ssdia2 + "/" + ssmes2  + "/" + saño2
          }
          
          let dur =  Math.floor(exporta[i].Duracion);
          if (exporta[i].Duracion < 1)
              dur = 1;        
  
          _exp.push({ 
            Curp: exporta[i].Curp,
            Nombre: exporta[i].Nombre,
            PrimerApellido: exporta[i].PrimerApellido,
            SegundoApellido: exporta[i].SegundoApellido,
            ClaveEstado: exporta[i].ClaveEstado,
            ClaveMunicipio: exporta[i].ClaveMunicipio,
            ClaveOcupacion: exporta[i].ClaveOcupacion,
            ClaveNivEstudios: exporta[i].ClaveNivEstudios, 
            ClaveDocProbatorio: exporta[i].ClaveDocProbatorio,
            ClaveInstitucion: exporta[i].ClaveInstitucion,
            ClaveCurso: '',
            CourseName: exporta[i].CourseName,
            ClaveAreaTematica: exporta[i].ClaveAreaTematica,
            Duracion: dur,
            Begin: sfecha1,
            End: sfecha2,
            ClaveTipAgente: exporta[i].ClaveTipAgente,
            RfcAgente: exporta[i].RfcAgente,
            ClaveModalidad: exporta[i].ClaveModalidad,
            ClaveCapacitacion: exporta[i].ClaveCapacitacion,
            ClaveEstablecimiento: exporta[i].ClaveEstablecimiento,
            Trainer: exporta[i].Trainer
          });
        }
  
  
        const worksheet = xlsx.utils.sheet_add_json(ws, _exp, { origin: 'A2', skipHeader: true });
        const workbook = { Sheets: { 'CONSTANCIAS': worksheet }, SheetNames: ['CONSTANCIAS'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, 'DC4 - ' + this.mes[this.selmes.id - 1].nombre);        
      });
    }
    

    
    saveAsExcelFile(buffer: any, fileName: string): void {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
          type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
      
    }

   
}
